import * as R from "ramda";
import React from "react";
import { connect } from "react-redux";
import { Draggable } from "react-beautiful-dnd";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import { DEFAULT_PROCESS_STEPS } from "../../../../../../constants/opportunity";

import SendOffer from "./SendOffer";
import ProcessCard from "./ProcessCard";

import styled from "styled-components/macro";

const getDragStyles = (isDragging, styles) => ({
  ...styles,
  transform: isDragging
    ? `${styles.transform || ""} rotate(5deg) scale(1.05)`
    : `${styles.transform || ""} rotate(0deg) scale(1)`,
  boxShadow: isDragging
    ? `${styles.boxShadow ||
        ""} 0 0 1px rgba(67, 90, 111, 0.3), 0 16px 24px -8px rgba(67, 90, 111, 0.47)`
    : `${styles.boxShadow || ""} 0 1px 3px 0 rgba(0, 0, 0, 0.15)`
});

const Container = styled.div`
  background-color: ${({ theme }) => theme["@light"]};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 8px;
  transition: 0.3s;
  width: 276px;

  &:hover {
    background-color: ${({ theme }) => theme["@grey-lighter"]};
  }
`;

const Match = props => {
  const {
    data: match,
    mode,
    canMove,
    sendOffer,
    isLoading,
    index,
    step,
    selectCandidate,
    selectedCandidates,
    stepIsDisabled
  } = props;

  const [showSendOffer, setShowSendOffer] = React.useState(false);
  const isDragDisabled = Boolean(
    isLoading ||
      !canMove ||
      step.name === DEFAULT_PROCESS_STEPS.accepted ||
      match.loading ||
      stepIsDisabled
  );

  return (
    <>
      <Draggable
        key={match.id}
        draggableId={match.id}
        index={index}
        isDragDisabled={isDragDisabled}
        disableInteractiveElementBlocking
      >
        {(provided, snapshot) => (
          <Container
            data-test={`match.${match.id}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getDragStyles(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <ProcessCard
              onSelect={selected =>
                selectCandidate({ candidate: match, selected, step })
              }
              isSelected={R.includes(match.id, selectedCandidates)}
              compact={mode === "compact"}
              showOffer={() => setShowSendOffer(true)}
              {...props}
            />
          </Container>
        )}
      </Draggable>
      {showSendOffer && (
        <SendOffer
          onClose={() => setShowSendOffer(false)}
          match={props}
          onSubmit={sendOffer}
        />
      )}
    </>
  );
};

export default compose(
  connect((state, ownProps) => {
    const messages = R.pathOr([], ["messages", "newMessages"], state);
    const opportunity = R.path(["opportunity", "selected"], state);
    const candidateId = R.path(["data", "id"], ownProps);

    const unreadMessages = R.pipe(
      R.filter(
        R.both(
          R.propEq("idCandidate", candidateId),
          R.propEq("idOpportunity", opportunity.id)
        )
      ),
      R.length
    )(messages);

    return {
      unreadMessages
    };
  }),
  withRouter,
  withTranslation(["opportunity", "components"])
)(Match);
